import { Component } from 'react';
import { connect, PromiseState } from 'react-refetch';
import { Link } from 'react-router';
import Helmet from 'react-helmet';

import { GoogleMap, GoogleMapLoader, Marker } from 'react-google-maps';

import { api, gmap, titles } from '../data';

import LoadingAnimation from './modules/LoadingAnimation';
import Title from './modules/Title';

class Gmap extends Component {

  render() {
    const mapInfo = this.props.mapInfo;
    const mapStyles = [{"featureType": "administrative","elementType": "labels.text.fill","stylers": [{"color": "#444444"}]},{"featureType": "landscape","elementType": "all","stylers": [{"color": "#f2f2f2"}]},{"featureType": "landscape","elementType": "geometry","stylers": [{"color": "#fffffa"}]},{"featureType": "landscape.man_made","elementType": "geometry.fill","stylers": [{"color": "#fffffa"}]},{"featureType": "poi","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "road","elementType": "all","stylers": [{"saturation": -100},{"lightness": 45}]},{"featureType": "road","elementType": "geometry.fill","stylers": [{"hue": "#ff0000"}]},{"featureType": "road.highway","elementType": "all","stylers": [{"visibility": "simplified"}]},{"featureType": "road.highway","elementType": "geometry","stylers": [{"color": "#fdcfdd"}]},{"featureType": "road.arterial","elementType": "labels.icon","stylers": [{"visibility": "off"}]},{"featureType": "transit","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "water","elementType": "all","stylers": [{"color": "#5b8ece"},{"visibility": "on"}]}];
    const myLatLng = new google.maps.LatLng(mapInfo.lat, mapInfo.lng);
    const markerIcon = gmap.markerIcon;

    return (
      <GoogleMapLoader
        googleMapElement={
          <GoogleMap
            defaultZoom={14}
            defaultCenter={myLatLng}
            defaultOptions={{ styles: mapStyles}}>
            <Marker
              ref="marker"
              position={myLatLng}
              icon={markerIcon}
            />
          </GoogleMap>
        }
      />
    )
  }
}

class About extends Component {
  render() {

    const page = this.props.page;
    const corpInfo = this.props.page.acf.corp_info[0];

    return (
      <div>
        <Helmet title={titles.about} titleTemplate={titles.titleTemplate} />
        <section className="about">
          <Title header="h1" title="健やかネットワークについて" />
          {page.acf.top_img
            ? <figure className="about__img" style={{'backgroundImage': `url(${page.acf.top_img})`}} />
            : ''
          }
          <div className="about__content">
            {page.acf.overview
              ?
                <div className="about__content__desc">
                  <div className="overview" dangerouslySetInnerHTML={{__html: page.acf.overview}} />
                </div>
              : ''
            }
            <table className="about__table">
              <tbody>
                {corpInfo.name
                  ?
                    <tr>
                      <th>法人名</th>
                      <td>{corpInfo.name}</td>
                    </tr>
                  : ''
                }

                <tr className="spacer" />

                {corpInfo.address
                  ?
                    <tr>
                      <th>住所</th>
                      <td>{corpInfo.address}</td>
                    </tr>
                  : ''
                }

                <tr className="spacer" />

                {corpInfo.content
                  ?
                    <tr>
                      <th>事業内容</th>
                      <td dangerouslySetInnerHTML={{__html: corpInfo.content}} />
                    </tr>
                  : ''
                }

                <tr className="spacer" />

                {corpInfo.contact
                  ?
                    <tr>
                      <th>お問い合わせ先</th>
                      <td dangerouslySetInnerHTML={{__html: corpInfo.contact}} />
                    </tr>
                  : ''
                }

                <tr className="spacer" />

                {corpInfo.access_map
                  ?
                    <tr className="gmap">
                      <th>アクセス</th>
                      <td><Gmap mapInfo={corpInfo.access_map} /></td>
                    </tr>
                  : ''
                }

                <tr className="spacer" />

                {corpInfo.links
                  ?
                    <tr>
                      <th>リンク集</th>
                      <td><Link to="/links">アンジュグループ</Link></td>
                    </tr>
                  : ''
                }
              </tbody>
            </table>
          </div>
        </section>
      </div>
    )
  }
}

class AboutFetch extends Component {
  render() {

    const { pageFetch } = this.props;

    const allFetches = PromiseState.all([pageFetch])

    // Pending
    if (allFetches.pending) {

      return <LoadingAnimation />

    // Error
    } else if (allFetches.rejected) {

      return <div>Error</div>

    // Complete without Error
    } else if (allFetches.fulfilled) {

      let [page] = allFetches.value;
      page = page[0];

      return (
        <div>
          <About page={page} />
        </div>
      )
    }
  }
}

export default connect(() => ({
  pageFetch: `${api.base_url}/pages?slug=about`
}))(AboutFetch);



/** WEBPACK FOOTER **
 ** ./src/components/About.js
 **/